import { PatientConsentBaseViewModel } from "./PatientConsentBaseViewModel";
export class PatientConsentSetupCompletionViewModel extends PatientConsentBaseViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
        this.accountSetupCompletionManager = container.accountSetupCompletionManager;
        const patientInfo = this.patientConsentUIManager.consentingPatientInfo;
        this.accountSetupCompletionManager.prepopulate(patientInfo);
    }
    get formModel() {
        return this.accountSetupCompletionManager.formModel;
    }
    get hasAgeValidationError() {
        return this.accountSetupCompletionManager.hasAgeValidationError;
    }
    async continue() {
        if (!this.accountSetupCompletionManager.validateInput())
            return;
        const success = await this.patientConsentUIManager.updatePatient({
            firstName: this.accountSetupCompletionManager.input.firstName,
            lastName: this.accountSetupCompletionManager.input.lastName,
            dateOfBirth: this.accountSetupCompletionManager.input.birthday,
            phone: this.accountSetupCompletionManager.input.mobilePhone,
        });
        if (success) {
            const nextPage = this.patientConsentUIManager.getNextPageRoute();
            this.authManager.setAccountSetupCompleted(true);
            await this.authManager.regenerateToken();
            if (nextPage) {
                this.patientConsentUIManager.goToPage(nextPage);
            }
            else {
                console.error("No next page found while going to next page");
            }
        }
        else {
            console.error("Failed to update patient");
        }
    }
}
